import { render, staticRenderFns } from "./BookInfo_phone.vue?vue&type=template&id=8c347152&scoped=true"
import script from "./BookInfo_phone.vue?vue&type=script&lang=js"
export * from "./BookInfo_phone.vue?vue&type=script&lang=js"
import style0 from "./BookInfo_phone.vue?vue&type=style&index=0&id=8c347152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c347152",
  null
  
)

export default component.exports